// extracted by mini-css-extract-plugin
module.exports = {"root":"autocomplete-item_root__TLPLB","history":"autocomplete-item_history__Earlg","content":"autocomplete-item_content__HHoNI","active":"autocomplete-item_active__oRWpe"};